import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
import { ShopRoutes } from '#lib/websites/shop/constants/routes.js';
import type { ShopPdpBook } from '#lib/websites/shop/pages/ShopBookPdp/types.js';
import type { Crumb } from '$global/components/Breadcrumbs';

export const getBookCrumbs = (
	book: ShopPdpBook,
	series?: { id?: string | number | null; title?: string | null } | null
): Crumb[] => [
	{
		label: 'Home',
		href: GlobalRoutes.Home,
	},
	{
		label: 'Shop',
		href: GlobalRoutes.ShopHome,
	},
	{
		label: 'Books',
		href: ShopRoutes.Books,
	},
	...(series?.title && series?.id
		? [
				{
					label: series.title,
					href: `${ShopRoutes.BookSeries}/${series.id}`,
				},
			]
		: []),
	{
		label: book?.title || '',
	},
];
